import React, { useEffect } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import PageLayout from "../layout/PageLayout";
import { submitAgreement } from "../utils/agreements";
import { PADDLE_GTCS_TEXT } from "../constants/dpaText";

const ThankYouPage = () => {
  const { state } = useLocation();
  const [searchParams] = useSearchParams();
  const { userData, venueId: venueIdState, type: typeState } = state || {};
  const venueId = venueIdState || searchParams.get("vid") || searchParams.get("venueId") || sessionStorage.getItem("checkoutVenueId");
  const type = typeState || searchParams.get("type") || sessionStorage.getItem("checkoutType");
  const emailOverride = sessionStorage.getItem("checkoutEmail");
  const partnerLogoUrl = state?.partnerLogoUrl || (typeof window !== 'undefined' ? sessionStorage.getItem('partnerLogoUrl') || undefined : undefined);
  const customUi = state?.customUi ?? (typeof window !== 'undefined' ? sessionStorage.getItem('customUi') === 'true' : undefined);

  useEffect(() => {
    const run = async () => {
      try {
        if (!venueId || !type) return;
        let clientIp = null;
        try {
          const res = await fetch('https://api.ipify.org?format=json');
          const data = await res.json();
          clientIp = data?.ip || null;
        } catch (_) {}

        const productMap = {
          listing: "listing",
          michelin: "michelin",
          smartchannel: "booking-receiver",
          meta: "meta",
        };
        const product = productMap[type] || type;

        await submitAgreement({
          venueId,
          product,
          details: {
            firstName: userData?.name || "",
            lastName: userData?.lastName || "",
            restaurantName: userData?.company?.legalName || userData?.company?.name || "",
            address: userData?.company?.address || "",
            userId: userData?.id || "",
            venueId,
            email: emailOverride || userData?.email || "",
            googlePlaceId: null,
            agreementAcceptedAt: new Date().toISOString(),
          },
          dpaText: PADDLE_GTCS_TEXT,
          clientIp,
          userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : '',
        });
      } catch (e) {
        // Non-blocking – thank you page should not error out for users
        console.warn("Failed to submit Paddle agreement", e);
      }
    };
    run();
  }, [userData, venueId, type, emailOverride]);

  const productMap = {
    listing: "Listing & Review",
    michelin: "The MICHELIN Guide",
    smartchannel: "Booking Receiver",
    meta: "Meta",
  };
  const productLabel = productMap[type] || "Mozrest";

  // No explicit close button; inform user they may now close the window

  return (
    <PageLayout type={type || "meta"} partnerLogoUrl={partnerLogoUrl} customUi={customUi}>
      <div className="confirm-container">
        <div className="confirm-icon">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="12" fill="#33C27F"/>
            <path d="M7 12.5l3 3 7-7" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        <h2 className="confirm-title">Thank you{userData?.name ? `, ${userData.name}` : ""}!</h2>
        <p className="confirm-lead">
          Your subscription to <strong>{productLabel}</strong> is now active.
        </p>

        <div className="confirm-next">
          <h3>What happens next</h3>
          <ul>
            <li>We’ve recorded your acceptance of the terms and your subscription details and will proceed with the onboarding process.</li>
            <li>You’ll receive an email confirmation of your subscription from Paddle to {emailOverride || userData?.email}.</li>
            <li>If you need help, contact us at <a href="mailto:support@mozrest.com">support@mozrest.com</a>.</li>
          </ul>
        </div>

        <p className="confirm-footnote" style={{ marginTop: 24, color: "#667085", textAlign: "center" }}>
          You may now safely close this window. Thank you.
        </p>
      </div>
    </PageLayout>
  );
};

export default ThankYouPage;